"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateModifyButton = void 0;
const react_1 = __importStar(require("react"));
const react_components_1 = require("@cimpress/react-components");
const i18n_1 = require("../i18n");
const stereotype_api_1 = require("../apis/stereotype.api");
exports.TemplateModifyButton = (props) => {
    const [template, setTemplate] = react_1.useState(null);
    const [fetching, setFetching] = react_1.useState(false);
    const [fetchingError, setFetchingError] = react_1.useState(null);
    const t = i18n_1.getI18nInstance().getFixedT(props.language);
    react_1.useEffect(() => {
        if (props.accessToken && props.templateUrl) {
            setFetching(true);
            stereotype_api_1.getTemplate(props.accessToken, props.templateUrl)
                .then(template => {
                setFetching(false);
                setTemplate(template);
            })
                .catch(error => {
                setFetching(false);
                setFetchingError(error);
                if (props.onError) {
                    props.onError(error);
                }
            });
        }
    }, [props.templateUrl, props.accessToken]);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_components_1.Button, { href: "https://templatedesigner.cimpress.io/designer/" + encodeURIComponent((template || {}).templateId), target: '_blank', type: props.type || 'default', disabled: !props.templateUrl || fetching }, fetching
            ? t('loading')
            : t('modify-template-modal-button')));
};
//# sourceMappingURL=TemplateModifyButton.js.map